import React from 'react'
import './Footer.scss';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
    const location = useLocation();
    const isContactPage = location.pathname === '/contact';
    const isNewsletterPage = location.pathname === '/newsletter';

    return (
        <footer>
            <ul>
                <li>
                    {isContactPage ? (
                        <span className="active-link">contact</span>
                    ) : (
                        <Link to="/contact">contact</Link>
                    )}
                </li>
                <li>
                    {isNewsletterPage ? (
                        <span className="active-link">newsletter</span>
                    ) : (
                        <Link to="/newsletter">newsletter</Link>
                    )}
                </li>

            </ul>

        </footer>
    )
}

export default Footer